import React, { useState, useMemo, useEffect } from "react";
import MaterialTable from "material-table";
import {
  Grid,
  Input,
  NativeSelect,
  Paper,
  AccordionSummary,
  Typography,
  Accordion,
  AccordionDetails,
} from "@material-ui/core";
import { Link, useHistory, useParams } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { toast } from "react-toastify";

import Header from "../../../layout/Header";
import Loading from "../../../components/Loading";
import Subheader from "../../../layout/Subheader";
import useStyles from "./style";
import api from "../../../services/api";

import RedesPlataforma from "./redesPlataforma";
import RedesDisponiveis from "./redesDisponiveis";
import AnalistasRede from "./analistasRede";
import AnalistasDisponiveis from "./analistasDisponiveis";
import AnalistasPlataforma from "./analistasPlataforma";
import { ConfirmationBox } from "../../../components/ConfirmationBox";
import { formatDateTimeToRender } from "../../../utils/functions";
import { useMessageBox } from "../../../context/MessageBox";

export function PlatformRegister() {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [formValues, setFormValues] = useState({
    plataforma: "",
    supervisorLoginId: 0,
    status: "",
    dataAtualizacao: "",
    dataRegistro: "",
  });
  const [colaboradores, setColaboradores] = useState([]);
  const [redesPlataformas, setRedesPlataformas] = useState([]);
  const [redesDisponiveis, setRedesDisponiveis] = useState([]);
  const [analistasRede, setAnalistasRede] = useState([]);
  const [analistasDisponiveis, setAnalistasDisponiveis] = useState([]);
  const [analistasPlataforma, setAnalistasPlataforma] = useState([]);
  const [currentAncora, setCurrentAncora] = useState(0);
  const [currentPlataformaAncora, setCurrentPlataformaAncora] = useState(0);
  const [currentRede, setCurrentRede] = useState("");
  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: "",
    callback: () => {},
    rede: "",
  });
  const [hasFormChanged, setHasFormChanged] = useState(false);
  const { setMessageData } = useMessageBox();
  const [startActive, setStartActive] = useState(false);
  const [ becomeInactive, setBecomeInactive ] = useState(false);

  const onSubmit = async () => {
    if (
      formValues.plataforma &&
      formValues.supervisorLoginId &&
      formValues.status
    ) {
      setLoading(true);
      try {
        if (isRegister) {
          const request = {
            plataforma: formValues.plataforma,
            supervisorLoginId: Number(formValues.supervisorLoginId),
            status: formValues.status,
          };
          const response = await api.post("Plataformas", request);
          if (response?.data?.complemento?.mensagensBox?.length > 0) {
            setMessageData(response?.data?.complemento?.mensagensBox);
          }

          if (response.data.status !== "Sucesso") {
            if (response.data.resposta) {
              if (response.data.resposta.length > 0) {
                response.data.resposta.forEach((element) => {
                  toast.error(element.message);
                });

                return;
              }
            }
          }
          toast.success("Plataforma registrada com sucesso!");
          history.push(
            `/app/plataforma/${response.data.resposta.plataformaId}/editar`
          );
        } else if (id) {
          const request = {
            plataformaId: Number(id),
            plataforma: formValues.plataforma,
            supervisorLoginId: Number(formValues.supervisorLoginId),
            status: formValues.status,
            dataAtualizacao: formValues.dataAtualizacao,
          };
          const rep = await api.put("Plataformas", request);
          if (rep?.data?.complemento?.mensagensBox?.length > 0) {
            setMessageData(rep?.data?.complemento?.mensagensBox);
          }

          if (rep.data.status !== "Sucesso") {
            if (rep.data.resposta) {
              if (rep.data.resposta.length > 0) {
                rep.data.resposta.forEach((element) => {
                  toast.error(element.message);
                });

                return;
              }
            }
          }
          if (
            rep &&
            rep.data &&
            rep.data.resposta &&
            rep.data.resposta.dataAtualizacao
          ) {
            setFormValues((inputs) => ({
              ...inputs,
              ["dataAtualizacao"]: rep.data.resposta.dataAtualizacao,
            }));
          }
          toast.success("Plataforma alterada com sucesso!");
          setStartActive(request.status === "Ativo");
          setHasFormChanged(false);
          setCurrentAncora(0);
          setCurrentPlataformaAncora(0);
          await fetchTables();
          await fetchAnalistasPlataforma();
        }
        setLoading(false);
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message);
        } else {
          toast.error(
            "Detectamos um problema interno! tente novamente em instantes."
          );
        }
        setLoading(false);
      }
    }
  };

  const handleInactive = (event) => {
    if(id && event.target.value == 'Inativo') {
      setBecomeInactive(true);
    } 
    handleInputChange(event, event.target.value);
  }

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({
      ...inputs,
      [event.target.name]: value || event.target.value,
    }));
    setHasFormChanged(true);
  };

  const selectRede = async (rede) => {
    setCurrentAncora(0);
    setCurrentPlataformaAncora(0);
    await fetchAnalistasTables(rede.ancoraId, rede.plataformaAncoraId);
    setCurrentAncora(rede.ancoraId);
    setCurrentPlataformaAncora(rede.plataformaAncoraId);
    setCurrentRede(rede.rede);
  };

  const fetchAnalistasTables = async (ancoraId, plataformaAncoraId) => {
    try {
      const responseAnalistasRede = await api.get(
        `PlataformasAncorasAnalistas/ConsultarPlataformaAncoraIdAncoraId?plataformaAncoraId=${plataformaAncoraId}&ancoraId=${ancoraId}`
      );
      const responseAnalistasDisponiveis = await api.get(
        `PlataformasAncorasAnalistas/ConsultarDisponiveisPlataformaAncoraIdAncoraId?plataformaAncoraId=${plataformaAncoraId}&ancoraId=${ancoraId}`
      );

      if (responseAnalistasRede?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(responseAnalistasRede?.data?.complemento?.mensagensBox);
      }

      if (responseAnalistasRede.data.status !== "Sucesso") {
        if (responseAnalistasRede.data.resposta) {
          if (responseAnalistasRede.data.resposta.length > 0) {
            responseAnalistasRede.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (responseAnalistasRede?.data?.resposta) {
        setAnalistasRede(
          responseAnalistasRede.data.complemento.codigo === "204"
            ? []
            : responseAnalistasRede.data.resposta
        );
      } else {
        setAnalistasRede([]);
      }

      if (
        responseAnalistasDisponiveis?.data?.complemento?.mensagensBox?.length >
        0
      ) {
        setMessageData(
          responseAnalistasDisponiveis?.data?.complemento?.mensagensBox
        );
      }

      if (responseAnalistasDisponiveis.data.status !== "Sucesso") {
        if (responseAnalistasDisponiveis.data.resposta) {
          if (responseAnalistasDisponiveis.data.resposta.length > 0) {
            responseAnalistasDisponiveis.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (responseAnalistasDisponiveis?.data?.resposta) {
        setAnalistasDisponiveis(
          responseAnalistasDisponiveis.data.complemento.codigo === "204"
            ? []
            : responseAnalistasDisponiveis.data.resposta
        );
      } else {
        setAnalistasDisponiveis([]);
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
  };

  const fetchAnalistasPlataforma = async () => {
    try {
      const responseAnalistasPlataforma = await api.get(
        `PlataformasAncorasAnalistas/ConsultarAnalistasPlataformaId?plataformaId=${id}`
      );

      if (
        responseAnalistasPlataforma?.data?.complemento?.mensagensBox?.length > 0
      ) {
        setMessageData(
          responseAnalistasPlataforma?.data?.complemento?.mensagensBox
        );
      }

      if (responseAnalistasPlataforma.data.status !== "Sucesso") {
        if (responseAnalistasPlataforma.data.resposta) {
          if (responseAnalistasPlataforma.data.resposta.length > 0) {
            responseAnalistasPlataforma.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (responseAnalistasPlataforma?.data?.resposta) {
        setAnalistasPlataforma(
          responseAnalistasPlataforma.data.complemento.codigo === "204"
            ? []
            : responseAnalistasPlataforma.data.resposta
        );
      } else {
        setAnalistasPlataforma([]);
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
  };

  const fetchTables = async () => {
    try {
      const responseRedesPlataforma = await api.get(
        `PlataformasAncoras/ConsultarPlataformaId?id=${id}`
      );
      const responseRedesDisponiveis = await api.get(
        `PlataformasAncoras/ConsultarDisponiveisPlataformaId?id=${id}`
      );

      if (
        responseRedesPlataforma?.data?.complemento?.mensagensBox?.length > 0
      ) {
        setMessageData(
          responseRedesPlataforma?.data?.complemento?.mensagensBox
        );
      }

      if (responseRedesPlataforma.data.status !== "Sucesso") {
        if (responseRedesPlataforma.data.resposta) {
          if (responseRedesPlataforma.data.resposta.length > 0) {
            responseRedesPlataforma.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (responseRedesPlataforma?.data?.resposta) {
        setRedesPlataformas(
          responseRedesPlataforma.data.complemento.codigo === "204"
            ? []
            : responseRedesPlataforma.data.resposta
        );
      } else {
        setRedesPlataformas([]);
      }

      if (
        responseRedesDisponiveis?.data?.complemento?.mensagensBox?.length > 0
      ) {
        setMessageData(
          responseRedesDisponiveis?.data?.complemento?.mensagensBox
        );
      }

      if (responseRedesDisponiveis.data.status !== "Sucesso") {
        if (responseRedesDisponiveis.data.resposta) {
          if (responseRedesDisponiveis.data.resposta.length > 0) {
            responseRedesDisponiveis.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (responseRedesDisponiveis?.data?.resposta) {
        setRedesDisponiveis(
          responseRedesDisponiveis.data.complemento.codigo === "204"
            ? []
            : responseRedesDisponiveis.data.resposta
        );
      } else {
        setRedesDisponiveis([]);
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
  };

  const adicionarRede = async (rede) => {
    setLoading(true);
    try {
      const request = {
        plataformaId: rede.plataformaId,
        ancoraId: rede.ancoraId,
        status: "Ativo",
      };
      const rep = await api.post("PlataformasAncoras", request);

      if (rep?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(rep?.data?.complemento?.mensagensBox);
      }

      if (rep.data.status !== "Sucesso") {
        if (rep.data.resposta) {
          if (rep.data.resposta.length > 0) {
            rep.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (rep && rep.data && rep.data.resposta) {
        if (rep.data.resposta.dataAtualizacaoPlataforma) {
          setFormValues((inputs) => ({
            ...inputs,
            ["dataAtualizacao"]: rep.data.resposta.dataAtualizacaoPlataforma,
          }));
        }

        if (
          rep.data.resposta.ancoraId &&
          rep.data.resposta.plataformaAncoraId
        ) {
          await selectRede(rep.data.resposta);
        }
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
    await fetchTables();
    await fetchAnalistasPlataforma();
    setLoading(false);
  };

  const removerRede = async (rede) => {
    setLoading(true);
    try {
      //await removerTodosAnalistas(rede.plataformaAncoraId, rede.ancoraId)
      const request = {
        plataformaAncoraId: rede.plataformaAncoraId,
        plataformaId: rede.plataformaId,
        ancoraId: rede.ancoraId,
        status: "Inativo",
        dataAtualizacao: rede.dataAtualizacao,
      };
      const rep = await api.put("PlataformasAncoras", request);

      if (rep?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(rep?.data?.complemento?.mensagensBox);
      }

      if (rep.data.status !== "Sucesso") {
        if (rep.data.resposta) {
          if (rep.data.resposta.length > 0) {
            rep.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (
        rep &&
        rep.data &&
        rep.data.resposta &&
        rep.data.resposta.dataAtualizacaoPlataforma
      ) {
        setFormValues((inputs) => ({
          ...inputs,
          ["dataAtualizacao"]: rep.data.resposta.dataAtualizacaoPlataforma,
        }));
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
    setAnalistasDisponiveis([]);
    setAnalistasPlataforma([]);
    setCurrentAncora(0);
    setCurrentPlataformaAncora(0);
    setCurrentRede("");
    await fetchTables();
    await fetchAnalistasPlataforma();
    setLoading(false);
  };

  const abrirModalRemoverRede = (rede) => {
    setConfirmationBox({
      show: true,
      type: "removerRede",
      callback: () => {
        removerRede(rede);
      },
      rede: rede.rede,
    });
  };

  const removerTodosAnalistas = async (plataformaAncoraId, ancoraId) => {
    try {
      const responseAnalistasRede = await api.get(
        `PlataformasAncorasAnalistas/ConsultarPlataformaAncoraIdAncoraId?plataformaAncoraId=${plataformaAncoraId}&ancoraId=${ancoraId}`
      );

      if (responseAnalistasRede?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(responseAnalistasRede?.data?.complemento?.mensagensBox);
      }

      if (responseAnalistasRede.data.status !== "Sucesso") {
        if (responseAnalistasRede.data.resposta) {
          if (responseAnalistasRede.data.resposta.length > 0) {
            responseAnalistasRede.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      const listaAnalistas =
        responseAnalistasRede.data.complemento.codigo === "204"
          ? []
          : responseAnalistasRede.data.resposta;
      listaAnalistas.map(async (analista) => {
        const request = {
          plataformaAncoraAnalistaId: analista.plataformaAncoraAnalistaId,
          plataformaAncoraId: analista.plataformaAncoraId,
          ancoraId: analista.ancoraId,
          loginId: analista.loginId,
          status: "Inativo",
          dataAtualizacao: analista.dataAtualizacao,
        };
        const rep = await api.put("PlataformasAncorasAnalistas", request);

        if (rep?.data?.complemento?.mensagensBox?.length > 0) {
          setMessageData(rep?.data?.complemento?.mensagensBox);
        }

        if (rep.data.status !== "Sucesso") {
          if (rep.data.resposta) {
            if (rep.data.resposta.length > 0) {
              rep.data.resposta.forEach((element) => {
                toast.error(element.message);
              });

              return;
            }
          }
        }
      });
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
  };

  const adicionarAnalista = async (analista) => {
    try {
      const request = {
        plataformaAncoraId: analista.plataformaAncoraId,
        ancoraId: analista.ancoraId,
        loginId: analista.loginId,
        status: "Ativo",
      };
      const rep = await api.post("PlataformasAncorasAnalistas", request);

      if (rep?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(rep?.data?.complemento?.mensagensBox);
      }

      if (rep.data.status !== "Sucesso") {
        if (rep.data.resposta) {
          if (rep.data.resposta.length > 0) {
            rep.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (
        rep &&
        rep.data &&
        rep.data.resposta &&
        rep.data.resposta.dataAtualizacaoPlataforma
      ) {
        setFormValues((inputs) => ({
          ...inputs,
          ["dataAtualizacao"]: rep.data.resposta.dataAtualizacaoPlataforma,
        }));
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
    await fetchAnalistasPlataforma();
    await fetchAnalistasTables(currentAncora, currentPlataformaAncora);
  };

  const removerAnalista = async (analista) => {
    try {
      const request = {
        plataformaAncoraAnalistaId: analista.plataformaAncoraAnalistaId,
        plataformaAncoraId: analista.plataformaAncoraId,
        ancoraId: analista.ancoraId,
        loginId: analista.loginId,
        status: "Inativo",
        dataAtualizacao: analista.dataAtualizacao,
      };
      const rep = await api.put("PlataformasAncorasAnalistas", request);

      if (rep?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(rep?.data?.complemento?.mensagensBox);
      }

      if (rep.data.status !== "Sucesso") {
        if (rep.data.resposta) {
          if (rep.data.resposta.length > 0) {
            rep.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      if (
        rep &&
        rep.data &&
        rep.data.resposta &&
        rep.data.resposta.dataAtualizacaoPlataforma
      ) {
        setFormValues((inputs) => ({
          ...inputs,
          ["dataAtualizacao"]: rep.data.resposta.dataAtualizacaoPlataforma,
        }));
      }
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
    await fetchAnalistasPlataforma();
    await fetchAnalistasTables(currentAncora, currentPlataformaAncora);
  };

  const fetchColoaboradores = async () => {
    try {
      const rep = await api.get("Colaboradores/Consultar?status=Contratado");
      if (rep?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(rep?.data?.complemento?.mensagensBox);
      }

      if (rep.data.status !== "Sucesso") {
        if (rep.data.resposta) {
          if (rep.data.resposta.length > 0) {
            rep.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }
      setColaboradores(rep.data.resposta);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
  };

  const fetchPlataforma = async (plataformaId) => {
    try {
      const rep = await api.get(`Plataformas/ConsultarId?id=${plataformaId}`);

      if (rep?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(rep?.data?.complemento?.mensagensBox);
      }

      if (rep.data.status !== "Sucesso") {
        if (rep.data.resposta) {
          if (rep.data.resposta.length > 0) {
            rep.data.resposta.forEach((element) => {
              toast.error(element.message);
            });

            return;
          }
        }
      }

      setFormValues({
        plataforma: rep.data.resposta.plataforma,
        supervisorLoginId: rep.data.resposta.supervisorLoginId,
        status: rep.data.resposta.status,
        dataAtualizacao: rep.data.resposta.dataAtualizacao,
        dataRegistro: rep.data.resposta.dataRegistro,
      });
      setStartActive(rep.data.resposta.status === "Ativo");
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error(
          "Detectamos um problema interno! tente novamente em instantes."
        );
      }
    }
  };

  const initialize = async () => {
    setLoading(true);
    await fetchColoaboradores();
    if (window.location.pathname.includes("cadastrar")) {
      setIsEditing(true);
      setIsRegister(true);
    }
    if (id) {
      setIsEditing(window.location.pathname.includes("editar"));
      await fetchPlataforma(id);
      await fetchTables();
      await fetchAnalistasPlataforma();
    }
    setLoading(false);
  };

  const handleSubmit = () => {
    if(becomeInactive && formValues.status == 'Inativo') {
      setBecomeInactive(true);
      setConfirmationBox({
        show: true,
        type: "inactivePlatform",
        callback: () => {
          onSubmit();
        },
        plataforma: formValues.plataforma
      });
    } else {
      onSubmit();
    }
  }

  useEffect(() => {
    initialize();
  }, [id]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? "Cadastrando" : "Atualizando"} Plataforma${
            isRegister ? "" : " " + formValues.plataforma
          }`}
          isDisabled={isLoading || !hasFormChanged}
          back='/app/plataformas'
          loading={isLoading || !hasFormChanged}
          submit={handleSubmit}
          submitText={"Gravar"}
        />
      ) : (
        <Subheader
          back='/app/plataformas'
          loading={isLoading}
          title={`Visualizando Plataforma ${formValues.plataforma}`}
        />
      )}
      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}></ConfirmationBox>
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          <div>
            <form onSubmit={handleSubmit}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className={classes.summary}>
                  <Typography className={classes.heading}>
                    Dados da Plataforma
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={4}>
                      <label className={classes.label}>Plataforma</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          disabled={!isEditing}
                          value={formValues.plataforma}
                          name='plataforma'
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={4}>
                      <label className={classes.label}>Surpevisor</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={!isEditing}
                          value={formValues.supervisorLoginId}
                          name='supervisorLoginId'
                          onChange={handleInputChange}>
                          <option value=''>Selecione colaborador</option>
                          {colaboradores?.map((colaborador) => (
                            <option
                              key={colaborador.loginId}
                              value={colaborador.loginId}>
                              {colaborador.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={4}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={!isEditing}
                          value={formValues.status}
                          name='status'
                          onChange={handleInactive}>
                          <option value=''>Selecione Status</option>
                          <option value='Ativo'>Ativo</option>
                          <option value='Inativo'>Inativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </form>
            {!isRegister && startActive && (
              <>
                {isLoading ? (
                  <Loading />
                ) : (
                  <div style={{ marginTop: "20px", width: "100%" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <div className={classes.tablesContainer}>
                          <RedesPlataforma
                            tableData={redesPlataformas}
                            selectRede={selectRede}
                            ancoraId={currentAncora}
                            disabled={!isEditing}
                            removerRede={abrirModalRemoverRede}
                            plataforma={formValues.plataforma}
                          />
                          <RedesDisponiveis
                            tableData={redesDisponiveis}
                            disabled={!isEditing}
                            adicionarRede={adicionarRede}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className={classes.tablesContainer}>
                          {currentPlataformaAncora ? (
                            <AnalistasRede
                              tableData={analistasRede}
                              rede={currentRede}
                              removerAnalista={removerAnalista}
                              disabled={!isEditing}
                            />
                          ) : (
                            <></>
                          )}
                          {currentPlataformaAncora ? (
                            <AnalistasDisponiveis
                              adicionarAnalistas={adicionarAnalista}
                              tableData={analistasDisponiveis}
                              disabled={!isEditing}
                            />
                          ) : (
                            <></>
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className={classes.tablesContainer}>
                          <AnalistasPlataforma
                            tableData={analistasPlataforma}
                            plataforma={formValues.plataforma}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </>
            )}
            {!isRegister && (
              <div style={{ marginTop: "20px" }}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={classes.summary}>
                    <Typography className={classes.heading}>
                      Dados do Registro
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>
                          Data de Registro
                        </label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            disabled
                            value={
                              formValues.dataRegistro
                                ? formatDateTimeToRender(
                                    formValues.dataRegistro
                                  )
                                : ""
                            }
                            name='dataRegistro'
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>
                          Data da Atualização
                        </label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            disabled
                            value={
                              formValues.dataAtualizacao
                                ? formatDateTimeToRender(
                                    formValues.dataAtualizacao
                                  )
                                : ""
                            }
                            name='dataAtualizacao'
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
